export enum DocumentTextLocationEnum {
  INTRO = 'INTRO',
  OUTRO = 'OUTRO',
  CUSTOM_EMAIL_TEXT = 'CUSTOM_EMAIL_TEXT',
}
